/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2022-02-21 16:42:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/api/store.js
 */
/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：店铺管理相关接口
 */
import { get, post, put, deletes } from "@common/http";

import env from "@common/env";

const yapiUrl = env.yapiUrl;
///user-info/{userId}
/**
 * 获取店铺列表
 * @param {*} param
 */
export const getTenentListData = (param, id) =>
    get(`/tenant/${id ? id : ""}`, param);

export const getTenentData = (id) =>
    get(`/tenant/${id}`);

/**
 * 获取店铺列表
 * @param {*} param
 */
export const getNewTenentListData = id => get(`/user-tenant/${id}`);
/**
 * 获取用户信息
 * @param {*} param
 */
export const getUserInfo = id => get(`/user-info/${id}`);

/**
 * 修改手机
 * @param {*} param
 */
export const modifySetMobile = param => post(`/modify-mobile`, param);
/**
 * 修改密码
 * @param {*} param
 */
export const modifyPassword = param => post(`/user/change-pwd`, param);
/**
 * 获取店铺列表
 * @param {*} param
 */
export const modifyTenent = param => put(`/tenant/`, param);

export const postModifyTenent = param => post(`/tenant/`, param);

export const deleteTenent = id => deletes(`/tenant/${id}`);

/**
 * 添加门店
 * @param {*} param
 */
export const createTenantStore = param => post(`/tenant`, param);

// 点击门店进入的时候获取token
export const chooseTenant = (param, config) =>
    post(`/user/choose-tenant`, param, config);

/**
 * 店铺管理-连锁管理-连锁店铺列表
 * @param param
 * @returns {*}
 */
export const getStoreChianData = param =>
    post(yapiUrl + "/store/getChainList", param);

/**
 * 获取数据
 * @param param
 * @returns {*}
 */
export const getData = param => get("/getData", param);

/**
 * 添加店铺
 * @param param
 * @returns {*}
 */
export const storeCreate = param => post("/uc-service/tenant/create", param);

/**
 * 操作记录
 * @param param
 * @returns {*}
 */
export const logOperationRecord = param => get("/log-operation-record", param);

/**
 * 获取二维码
 *
 */
export const getQrcode = param => get("/wx/notify/qrcode", param);

/**
 * 获取反馈数据列表
 *
 */
export const getFeedBackList = param => get("/t-tenant-customer-feedback/getFeedBackList", param);

/**
 * 反馈回复
 *
 */
export const postAddReply = param => post("/t-tenant-reply/addReply", param);

/**
 * 反馈详情
 *
 */
export const getFeedBackListDetail = param => get("/t-tenant-customer-feedback/feedBackListDetail", param);

/**
 * 反馈信息状态
 *
 */
export const getChangeStatus = param => get("/t-tenant-customer-feedback/changeStatus", param);

export const feedBackStatus = id => get(`/t-tenant-customer-feedback/${id}`);

// 留言撤回
export const replyRevoke = id => get(`/t-tenant-reply/replyRevoke?id=${id}`);
// 获取有效职位列表
export const searchJob = _ => get('tenant-post/searchJob')
// 获取轮牌数据列表
export const getsWheelSettings = _ => get('/wheelPlateSetting/getsWheelSettings')
// 保存数据
export const wheelPlateSettingEdit = data => post('/wheelPlateSetting/edit', data)
// 删除数据
export const removeTheWheel = deleteID => deletes(`/wheelPlateSetting/${deleteID}`)
// 获取轮牌列表
export const wheelPlateSetting = _ => get('/wheelPlateSetting')
// 更新卡牌顺序
export const updateCardOrder = data => post('/wheelEmployee/conversion', data)
// 获取有效员工
export const wheelEmployee = data => get(`/wheelEmployee/canBeAddedEmployee?WHEEL_ID=${data}`)
// 更新状态
export const updateStatus = data => post('/wheelEmployee/edit', data)
// 添加员工
export const increaseEffectiveStaff = data => post('/wheelEmployee/add', data)
// 修改顺序
export const updateDataSequence = data => post('/wheelPlateSetting/conversion', data)



// WEBPACK FOOTER //
// ./src/api/store.js